type BrowserTypes = 'Opera' | 'Edge' | 'Chrome' | 'Safari' | 'Firefox'

function browserType(): BrowserTypes | null {
  const ua = navigator.userAgent

  if ((ua.indexOf("Opera") !== -1 || ua.indexOf('OPR')) !== -1) {
    return 'Opera';
  } else if (ua.indexOf("Edg") !== -1) {
    return 'Edge';
  } else if (ua.indexOf("Chrome") !== -1 && ua.indexOf("Chromium") === -1) {
    return 'Chrome';
  } else if (ua.indexOf("Safari") !== -1 && (ua.indexOf("Chrome") === -1 || ua.indexOf("Chromium") === -1)) {
    return 'Safari';
  } else if (ua.indexOf("Firefox") !== -1 && ua.indexOf("Seamonkey") === -1) {
    return 'Firefox';
  } else {
    return null
  }
}

export default browserType
